import { Typography } from '@global-engineering-shared/gweb-material-ui';
import { LinearProgress } from '@material-ui/core';

import { getPercentageValue } from 'features/Health/components/MonetisationHealthPercentageBar/utils/getPercentageValue';

import useStyles from './MonetisationHealthPercentageBar.styles';

type MonetisationHealthPercentageBarProps = {
  label: string;
  value: number;
  color: string;
};

const MonetisationHealthPercentageBar = ({
  label,
  value,
  color,
}: MonetisationHealthPercentageBarProps) => {
  const classes = useStyles({ color });
  return (
    <div className={classes.container}>
      <Typography variant="label" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="h2" fontWeight="bold">
        {Math.round(value)}%
      </Typography>
      <LinearProgress
        classes={{
          root: classes.root,
          bar: classes.bar,
        }}
        variant="determinate"
        value={getPercentageValue(value)}
      />
    </div>
  );
};

export default MonetisationHealthPercentageBar;
